const increment = (input) => {
  const currentValue = parseInt(input.value)

  input.value = currentValue + 1
}
const decrement = (input) => {
  const currentValue = parseInt(input.value)

  input.value = (currentValue <= 1) ? 1 : currentValue - 1
}

const actions = (input) => {
  const parent = input.closest('.input-increment')
  const decrementBtn = parent.querySelector('.decrement')
  const incrementBtn = parent.querySelector('.increment')

  incrementBtn.addEventListener('click', (e) => {
    e.preventDefault()
    increment(input)
  })
  decrementBtn.addEventListener('click', (e) => {
    e.preventDefault()
    decrement(input)
  })

  input.addEventListener('change', (e) => {
    if(e.currentTarget.value === '' || e.currentTarget.value <= 0) e.currentTarget.value = 1
  })
}

const InputIncrement = () => {
  const inputs = document.querySelectorAll('.input-increment input')

  if(!inputs.length > 0) return

  inputs.forEach((input) => {
    actions(input)
  })
}
export default InputIncrement
